import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=457ac1af&scoped=true"
import script from "./VCheckbox.vue?vue&type=script&lang=ts"
export * from "./VCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=457ac1af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ac1af",
  null
  
)

export default component.exports